import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import {IProps, IState} from './types';
import * as S from './styles';
import SelectDescribeIcon from '@assets/icons/selectDescribeIcon';
import EditIcon from '@assets/icons/editIcon';
import DeleteIcon from '@assets/icons/deleteIcon';
import CreateACopyIcon from '@assets/icons/createACopyIcon';
import FullPreviewIcon from '@assets/icons/fullPreviewIcon';
import { useLocation } from "react-router-dom";

const Options:React.FC<IProps> = (props) => {
  const [isInListTemplates, setIsInListTemplates]=useState<boolean|undefined>();
  const [totalOffSetTop, setTotalOffSetTop]=useState(0);
  const history: any = useHistory()

  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  useEffect(() => {
    if(optionsRef && optionsRef.current){
      //check offsettop
      let element: any = optionsRef.current
      if (["/templates", "/studio"].includes(location.pathname)) {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-") && !(element.id as string).startsWith("item-row-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
      }
      //check isList
      if (location.pathname==="/templates") {
        element = optionsRef.current
        let inList = false;
        while (element && element.id!="itemsList") {
          element = element.parentElement;
        }
        if (element) {
          inList = true;;
        }
        setIsInListTemplates(inList);
      }
    }
  }, [optionsRef]);

  const handleSelectDescribe = () => {
    handleOpenEditor();
  }

  const handleEdit = () => {
    props.onActionsTemplate("EDIT", [props.item], props.index);
  }

  const handleDelete = () => {
    props.onActionsTemplate("DELETE", [props.item], props.index);
  }

  const handleDuplicate = () => {
    props.onActionsTemplate("DUPLICATE", [props.item], props.index);
    props.setOpen(false);
  }

  const handleOpenEditor = () => {
    if (props.item.parsedTree) window.open(`/editor/template/${props.item.id}`);
  }

  const handlePreview = () => {    
    props.onActionsTemplate("PREVIEW", [props.item], props.index);
    props.setOpen(false);
  }

  let location = useLocation();

  const returnLeftValue = () => {
    var value = props.coordinates.x;
    if (location.pathname==="/studio") {
      if (props.coordinates.x > 1000) {
        value -= 440;
      }
      else {
        value -= 100;
      }
    }
    if (location.pathname==="/templates" && !isInListTemplates) {
      if (props.coordinates.x > 1000) {
        value -= 410;
      }
      else {
        value -= 60;
      }
    }
    if (location.pathname==="/templates" && isInListTemplates) {
      value -= 420;
    }
    return value;
  }

  const returnTopValue = () => {
    var value = 0;
    if (location.pathname==="/studio") {
      value = totalOffSetTop - 140;
    }
    if (location.pathname==="/templates") {
      value = totalOffSetTop - 160;
      if (props.coordinates.y < 450 && !isInListTemplates) {
        value += 100;
      }
      if (isInListTemplates) {
        value += 110;
      }
      if (isInListTemplates && props.coordinates.y > 400 && props.coordinates.y < 560) {
        value -= 120;
      }
      if (isInListTemplates && props.coordinates.y >= 560 && props.coordinates.y < 610) {
        value -= 240;
      }
      if (isInListTemplates && props.coordinates.y >= 610) {
        value -= 360;
      }
    }
    return value;
  }

  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
      onClick={(e:any)=>{
          e.preventDefault();
          e.stopPropagation();
      }}
    >
      {
        props.open &&
        <S.PopupContainer>
          <S.Title>
            {props.item.name}
          </S.Title>
          <S.DescriptionContainer>
            {props.item.organization &&
            <S.Description>
              {`Organization: ${props.item.organization}`}
            </S.Description>}
            <S.Description>
              {props.designType}
            </S.Description>
            <S.Description>
              {`Created: ${props.createdDate} by ${props.userName}`}
            </S.Description>
            <S.Description>
              {`Last Edited: ${props.lastEditedDate}`}
            </S.Description>
          </S.DescriptionContainer>
          <S.TopOptionsContainer>
            {
              location.pathname==="/templates" && 
              <S.OptionContainer
                onClick={handleSelectDescribe}
              >
                <S.OptionIconContainer>
                  <SelectDescribeIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Select & Describe Template`}
                </S.OptionText>
              </S.OptionContainer>
            }
            {
              location.pathname==="/templates" && 
              <S.OptionContainer
                onClick={handleEdit}
              >
                <S.OptionIconContainer>
                  <EditIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Edit Name, Tags and Status`}
                </S.OptionText>
              </S.OptionContainer>
            }
            {
              location.pathname==="/templates" && 
              <S.OptionContainer
                onClick={handleDuplicate}
              >
                <S.OptionIconContainer>
                  <CreateACopyIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Create a Copy`}
                </S.OptionText>
              </S.OptionContainer>
            }
            <S.OptionContainer
              onClick={handlePreview}
            >
              <S.OptionIconContainer>
                <FullPreviewIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Preview Template`}
              </S.OptionText>
            </S.OptionContainer>
            
          </S.TopOptionsContainer>
          {
            location.pathname==="/templates" && 
            <S.Divider />
          }
          {
            location.pathname==="/templates" && 
            <S.BottomOptionsContainer>
              <S.OptionContainer
                onClick={handleDelete}
              >
                <S.OptionIconContainer>
                  <DeleteIcon />
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Delete Template`}
                </S.OptionText>
              </S.OptionContainer>
            </S.BottomOptionsContainer>
          }
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default Options;